import styled from 'styled-components';
import CopyButton from 'components/ui/CopyButton';
import { ADMIN_BUTTON_BORDER_RADIUS, ADMIN_SURFACE_6 } from 'style/constants';

export default styled(CopyButton).attrs({ admin: true })`
  border-radius: ${ADMIN_BUTTON_BORDER_RADIUS};
  background-color: ${ADMIN_SURFACE_6};
`;
